export const solutionKeys = {
  all: ["solutions"] as const,
  list: () => ["solutions", "list"] as const,
  detail: (slug: string) => ["solutions", "detail", slug] as const,
  versions: (slug: string) => ["solutions", "versions", slug] as const,
  version: (slug: string, versionId: string) => ["solutions", "version", slug, versionId] as const,
  comments: (versionId: string) => ["comments", versionId] as const,
  shares: (slug: string) => ["solutions", "shares", slug] as const,
  media: (slug: string) => ["solutions", "media", slug] as const,
  share: (token: string) => ["share", token] as const,
};
